import React from 'react';
import { FileText, AlertCircle, CheckCircle } from 'lucide-react';

export const TermsConditions = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="container mx-auto px-4 max-w-4xl">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="flex justify-center mb-4">
            <FileText className="w-16 h-16 text-amber-600" />
          </div>
          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            Termos e Condições
          </h1>
          <p className="text-gray-600">
            Última atualização: Janeiro de 2026
          </p>
        </div>

        {/* Content */}
        <div className="bg-white rounded-xl shadow-lg p-8 space-y-8">
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              1. Aceitação dos Termos
            </h2>
            <p className="text-gray-700 leading-relaxed">
              Ao utilizar o website <strong>goviportugal.com</strong> e os serviços da GO VIP, 
              concorda com estes Termos e Condições. Se não concordar com estes termos, 
              não utilize os nossos serviços.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              2. Sobre a GO VIP
            </h2>
            <p className="text-gray-700 leading-relaxed">
              A GO VIP é uma empresa de transfers de luxo e tours privados, operando no Norte de Portugal 
              e Espanha. Oferecemos:
            </p>
            <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4 mt-3">
              <li>Transfers de/para o Aeroporto do Porto</li>
              <li>Tours privados personalizados</li>
              <li>Serviços de transporte executivo</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              3. Reservas e Confirmações
            </h2>
            
            <h3 className="font-semibold text-gray-900 mb-2 mt-4">3.1 Processo de Reserva</h3>
            <p className="text-gray-700 leading-relaxed">
              As reservas podem ser feitas através do website, WhatsApp ou telefone. 
              Todas as reservas estão sujeitas a disponibilidade.
            </p>

            <h3 className="font-semibold text-gray-900 mb-2 mt-4">3.2 Confirmação</h3>
            <p className="text-gray-700 leading-relaxed">
              Confirmamos todas as reservas no prazo de 24 horas. A reserva apenas é considerada 
              confirmada após receber a nossa confirmação por email, WhatsApp ou telefone.
            </p>

            <h3 className="font-semibold text-gray-900 mb-2 mt-4">3.3 Informações Necessárias</h3>
            <p className="text-gray-700 leading-relaxed">
              Para processar a reserva, necessitamos de: nome completo, contacto telefónico, email, 
              data e hora do serviço, número de passageiros e localização de recolha/entrega.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              4. Preços e Pagamento
            </h2>
            
            <h3 className="font-semibold text-gray-900 mb-2 mt-4">4.1 Preços</h3>
            <p className="text-gray-700 leading-relaxed">
              Os preços apresentados no website são indicativos e sujeitos a confirmação. 
              Todos os preços incluem IVA à taxa legal em vigor.
            </p>

            <h3 className="font-semibold text-gray-900 mb-2 mt-4">4.2 O Que Está Incluído</h3>
            <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
              <li>Motorista/guia profissional</li>
              <li>Combustível</li>
              <li>Portagens</li>
              <li>Seguro de passageiros</li>
              <li>Wi-Fi (quando disponível)</li>
            </ul>

            <h3 className="font-semibold text-gray-900 mb-2 mt-4">4.3 O Que NÃO Está Incluído</h3>
            <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
              <li>Refeições</li>
              <li>Entradas em monumentos/museus</li>
              <li>Despesas pessoais</li>
              <li>Gorjetas (opcionais)</li>
            </ul>

            <h3 className="font-semibold text-gray-900 mb-2 mt-4">4.4 Formas de Pagamento</h3>
            <p className="text-gray-700 leading-relaxed">
              Aceitamos pagamento em dinheiro (EUR) no final do serviço ou transferência bancária.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4 flex items-center">
              <AlertCircle className="w-6 h-6 mr-2 text-amber-600" />
              5. Política de Cancelamento
            </h2>
            
            <div className="bg-amber-50 p-6 rounded-lg space-y-3">
              <div className="flex items-start">
                <CheckCircle className="w-5 h-5 text-green-600 mr-2 mt-0.5 flex-shrink-0" />
                <div>
                  <p className="font-semibold text-gray-900">Cancelamento até 72h antes</p>
                  <p className="text-gray-700">Reembolso de 75% do valor pago</p>
                </div>
              </div>
              
              <div className="flex items-start">
                <AlertCircle className="w-5 h-5 text-yellow-600 mr-2 mt-0.5 flex-shrink-0" />
                <div>
                  <p className="font-semibold text-gray-900">Cancelamento entre 72h e 48h</p>
                  <p className="text-gray-700">Reembolso de 50% do valor pago</p>
                </div>
              </div>
              
              <div className="flex items-start">
                <AlertCircle className="w-5 h-5 text-red-600 mr-2 mt-0.5 flex-shrink-0" />
                <div>
                  <p className="font-semibold text-gray-900">Cancelamento com menos de 24h</p>
                  <p className="text-gray-700">Sem direito a reembolso</p>
                </div>
              </div>
            </div>

            <p className="text-gray-700 mt-4">
              Para cancelar, contacte-nos por WhatsApp, email ou telefone.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              6. Alterações e Reagendamento
            </h2>
            <p className="text-gray-700 leading-relaxed">
              Alterações à reserva estão sujeitas a disponibilidade. Solicitamos que nos contacte 
              com pelo menos 24 horas de antecedência. Alterações de última hora podem implicar custos adicionais.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              7. Responsabilidades do Cliente
            </h2>
            <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
              <li>Fornecer informações corretas e completas</li>
              <li>Estar presente no local combinado à hora marcada</li>
              <li>Informar sobre necessidades especiais com antecedência</li>
              <li>Respeitar o veículo e o motorista</li>
              <li>Não fumar no interior dos veículos</li>
              <li>Supervisionar crianças durante o serviço</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              8. Bagagem e Pertences
            </h2>
            <p className="text-gray-700 leading-relaxed">
              Cada passageiro tem direito a 1 mala grande e 1 mala de mão. Bagagem extra deve ser 
              comunicada previamente. A GO VIP não se responsabiliza por objetos esquecidos ou perdidos 
              durante o serviço.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              9. Atrasos e Voos
            </h2>
            <p className="text-gray-700 leading-relaxed mb-3">
              <strong>Transfers Aeroporto:</strong> Monitorizamos o seu voo. Em caso de atraso, 
              ajustamos a hora de recolha sem custos adicionais (até 2 horas de atraso).
            </p>
            <p className="text-gray-700 leading-relaxed">
              <strong>Tours:</strong> Atrasos significativos do cliente podem resultar em redução do tempo 
              do tour ou custos adicionais.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              10. Seguro e Segurança
            </h2>
            <p className="text-gray-700 leading-relaxed">
              Todos os veículos possuem seguro obrigatório e os motoristas são profissionais licenciados. 
              A segurança dos passageiros é a nossa prioridade máxima.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              11. Força Maior
            </h2>
            <p className="text-gray-700 leading-relaxed">
              A GO VIP não se responsabiliza por cancelamentos ou atrasos causados por circunstâncias 
              fora do nosso controlo (condições meteorológicas extremas, greves, desastres naturais, etc.). 
              Nestes casos, faremos o possível para reagendar ou reembolsar.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              12. Reclamações
            </h2>
            <p className="text-gray-700 leading-relaxed">
              Valorizamos o seu feedback. Reclamações devem ser enviadas por escrito para 
              Fantasticasfalto@gmail.com no prazo de 48 horas após o serviço. 
              Responderemos no prazo de 5 dias úteis.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              13. Lei Aplicável
            </h2>
            <p className="text-gray-700 leading-relaxed">
              Estes Termos e Condições regem-se pela lei portuguesa. Qualquer litígio será resolvido 
              pelos tribunais competentes em Portugal.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              14. Livro de Reclamações
            </h2>
            <p className="text-gray-700 leading-relaxed">
              A GO VIP dispõe de Livro de Reclamações, conforme legislação portuguesa. 
              Pode também apresentar a sua reclamação em <a href="https://www.livroreclamacoes.pt" target="_blank" rel="noopener noreferrer" className="text-amber-600 hover:underline">www.livroreclamacoes.pt</a>
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              15. Contacto
            </h2>
            <div className="bg-amber-50 p-6 rounded-lg">
              <p className="text-gray-700 mb-2"><strong>GO VIP</strong></p>
              <p className="text-gray-700">Email: Fantasticasfalto@gmail.com</p>
              <p className="text-gray-700">Telefone/WhatsApp: +351 932 651 940</p>
              <p className="text-gray-700">Website: goviportugal.com</p>
            </div>
          </section>

          <section className="border-t pt-6">
            <p className="text-sm text-gray-600 italic">
              Ao fazer uma reserva ou utilizar os nossos serviços, confirma que leu, compreendeu e 
              concordou com estes Termos e Condições.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};
